import React, { Suspense, lazy } from "react";

const ReactQueryDevtools = lazy(() => {
  return import("@tanstack/react-query-devtools").then((module) => ({
    default: module.ReactQueryDevtools
  }));
});

// Commenting prod react query tools, uncomment if use case to debug in prod/env arise.

// const ReactQueryDevtoolsProduction = React.lazy(() =>
//   import("@tanstack/react-query-devtools/build/lib/index.prod.js").then(
//     (module) => ({
//       default: module.ReactQueryDevtools
//     })
//   )
// );

export function ReactQueryDevTools() {
  const showDevtools = window.enableLog || localStorage.getItem("enableLog");
  return showDevtools ? (
    <>
      <Suspense fallback={null}>
        <ReactQueryDevtools />
        {/* <ReactQueryDevtoolsProduction position="bottom-right" /> */}
      </Suspense>
    </>
  ) : null;
}
